// extracted by mini-css-extract-plugin
export var container = "styles-module--container--3xRvT";
export var inner = "styles-module--inner--VR2fX";
export var subtitle = "styles-module--subtitle--2IHZ_";
export var title = "styles-module--title--fhMN8";
export var accordernControlsWrap = "styles-module--accordernControlsWrap--DuUA1";
export var jsAnimInit = "styles-module--jsAnimInit--2_OP5";